import {
  SupportedCountryAbbreviation,
  ISOCurrencyCode,
} from '@xbcb/shared-types';

const COUNTRY_CODE_TO_CURRENCY_MAP = {
  [SupportedCountryAbbreviation.US]: ISOCurrencyCode.USD,
  [SupportedCountryAbbreviation.GB]: ISOCurrencyCode.GBP,
  [SupportedCountryAbbreviation.UK]: ISOCurrencyCode.GBP,
  [SupportedCountryAbbreviation.DE]: ISOCurrencyCode.EUR,
  [SupportedCountryAbbreviation.NL]: ISOCurrencyCode.EUR,
  [SupportedCountryAbbreviation.FR]: ISOCurrencyCode.EUR,
  [SupportedCountryAbbreviation.IT]: ISOCurrencyCode.EUR,
  [SupportedCountryAbbreviation.ES]: ISOCurrencyCode.EUR,
  [SupportedCountryAbbreviation.PL]: ISOCurrencyCode.EUR,
  [SupportedCountryAbbreviation.AT]: ISOCurrencyCode.EUR,
  [SupportedCountryAbbreviation.CZ]: ISOCurrencyCode.EUR,
  [SupportedCountryAbbreviation.JP]: ISOCurrencyCode.JPY,
  [SupportedCountryAbbreviation.IN]: ISOCurrencyCode.INR,
  [SupportedCountryAbbreviation.BR]: ISOCurrencyCode.BRL,
  [SupportedCountryAbbreviation.AU]: ISOCurrencyCode.AUD,
  [SupportedCountryAbbreviation.CA]: ISOCurrencyCode.CAD,
  [SupportedCountryAbbreviation.IE]: ISOCurrencyCode.EUR,
} satisfies Record<SupportedCountryAbbreviation, ISOCurrencyCode>;
export const getCurrencyForCountryCode = (
  countryCode: SupportedCountryAbbreviation,
): string => {
  return COUNTRY_CODE_TO_CURRENCY_MAP[countryCode] || ISOCurrencyCode.USD;
};
